import { useQuery } from "@tanstack/react-query";
import { estimatesApi } from "../estimates";
import { EstimateStatisticsRequest } from "../types/model";

export const GET_ESTIMATES_KEY = "get_estimates";

export const useGetEstimates = (request: EstimateStatisticsRequest) => {
  return useQuery({
    queryKey: [
      GET_ESTIMATES_KEY,
      request.livingComplexId,
      request.contractor,
      request.oipd,
      request.costItem,
      request.contractNumber,
      request.actNumber
    ],
    queryFn: () => estimatesApi.GetDataByContractors(request),
    enabled: !!request.livingComplexId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    gcTime: 10 * 60 * 1000 // 10 минут
  });
}


